import "@/App.css";
import Navbar from "@/components/Navbar";
import Marquee from "@/components/Marquee";
import Hero from "@/components/sections/Hero";
import QuienesSomos from "@/components/sections/QuienesSomos";
import Metodologia from "@/components/sections/Metodologia";
import Sectores from "@/components/sections/Sectores";
import Trayectoria from "@/components/sections/Trayectoria";
import Footer from "@/components/Footer";
import { MARQUEE_ITEMS } from "@/data/content";

function App() {
  return (
    <div className="App bg-white antialiased selection:bg-[#E60000] selection:text-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee items={MARQUEE_ITEMS} dark testId="marquee-top" />
        <QuienesSomos />
        <Metodologia />
        <Sectores />
        <Trayectoria />
      </main>
      <Footer />
    </div>
  );
}

export default App;
